import AuthUtils from "../../../libs/utils/AuthUtils";

/**
 * 根据当前权限过滤路由菜单
 * @param routers
 * @param accessCode
 */
export function getMenuListByAccessCode(routers, accessCode) {
  let menuList = [];

  routers.forEach((item, index) => {
    if (item.access === undefined) {
      console.error("未定义路由权限", item.name);
      return;
    }
    //路由权限与当前用户权限匹配
    if (AuthUtils.isAccessMatched(item.access, accessCode)) {
      //如果没有二级菜单
      if (item.children.length === 1) {
        menuList.push(item);
      } else {//有二级菜单，遍历二级菜单的权限
        let len = menuList.push(item);
        let childrenArr = [];
        childrenArr = item.children.filter(child => {
          if (child.access !== undefined) {
            if (AuthUtils.isAccessMatched(child.access, accessCode)) {
              return child;
            }
          } else {
            return child;
          }
        });
        menuList[len - 1].children = childrenArr;
      }
    }
  });

  return menuList;
}

/**
 * 将router配置转换为tagList
 * @param routers
 */
export function mapRoutersToTagList(routers) {
  if (!routers) return null;
  let tagList = [];
  routers.forEach((item) => {
    if (item.children.length <= 1) {
      tagList.push(item.children[0]);
    } else {
      tagList.push(...item.children);
    }
  });
  return tagList;
}



// WEBPACK FOOTER //
// ./src/store/modules/app/helper.js